package com.bulut.mecitogullari.data.repository

import com.bulut.mecitogullari.core.util.YearMonth
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flatMapLatest
import kotlinx.coroutines.flow.flowOf
import kotlinx.coroutines.flow.map
import kotlinx.serialization.Serializable

/** Cash handover notes ("kasa devir notu"), one per accounting month. */
interface NotesRepository {
    /** "2026-7" → note text */
    val notes: Flow<Map<String, String>>
    suspend fun setNote(month: YearMonth, text: String)
}

@Serializable
internal data class MonthNoteDoc(val text: String = "")

class FirestoreNotesRepository : NotesRepository {

    @OptIn(ExperimentalCoroutinesApi::class)
    override val notes: Flow<Map<String, String>> =
        Firebase.auth.authStateChanged.flatMapLatest { user ->
            if (user == null) {
                flowOf(emptyMap())
            } else {
                userCollection(user.uid, COLLECTION).snapshots.map { snapshot ->
                    snapshot.documents.associate { doc ->
                        doc.id to (runCatching { doc.data<MonthNoteDoc>() }.getOrNull()?.text ?: "")
                    }
                }
            }
        }

    override suspend fun setNote(month: YearMonth, text: String) {
        val uid = currentUid() ?: return
        userCollection(uid, COLLECTION).document(month.key()).set(MonthNoteDoc(text))
    }

    private fun YearMonth.key(): String = "$year-$month"

    private companion object {
        const val COLLECTION = "monthNotes"
    }
}
